import React, { Component } from 'react';
import { Chart } from 'primereact/chart';
import { Buscar ,
    coordenadorVendas,
    coordenadorVendasOnly,
    coordenadorVendasOnlySupervisores
} from '../../services/contratos';

import { Card } from 'primereact/card';
import fundo_amarelo from '../../assets/fundo_amarelo.png';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import api from '../../services/backAxios/index';
import InputMask from 'react-input-mask';
import Organograma from '../organograma';
import { buscaHieraquia } from '../../services/hierarquia';
import { Dialog } from 'primereact/dialog';
import * as moment from 'moment';
import { CalculoComissao } from '../../services/comissoes';
import { decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';

let areaColaborador;
const vendedor = '';
const supervisor = '';
const nome = '';
const meses = [
    '',
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro'
];

export default class graficoComprasCoordenador extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cod: '',
            nome: decriptoLocalStorage('Nome')?.decriptoValue,
            dados: [],
            date: [],
            dato: [],
            teste: '',
            totalRecebidos: '',
            totalEntregues: '',
            loading: 'loading',
            displayBasic: false,
            hierarquia: false,
            permissao: '',
            submit: '',
            token: '',
            vendedor: '',
            dataMes: '',
            dataAno: '',
            bodyVend: '',
            bodySupp: '',
            comissao: ''
        };

        this.onClick = this.onClick.bind(this);
        this.onHide = this.onHide.bind(this);
        this.codigo = decriptoLocalStorage('codigo_vendedor')?.decriptoValue;
    }

    async componentDidMount() {
        const area = decriptoLocalStorage('area')?.decriptoValue;

        switch (area) {
        case '1':
            areaColaborador = 'EXTERNO';
            break;
        case '2':
            areaColaborador = 'TELEMARKETING';
            break;
        case '3':
            areaColaborador = 'PRIME';
            break;
        case '4':
            areaColaborador = 'PDV';
            break;
        case '5':
            areaColaborador = 'TERCEIRIZADO';
            break;
        default:
            areaColaborador = 'PRIME';
        }

        this.permissao = decriptoLocalStorage('PERM')?.decriptoValue;

        switch (this.permissao) {
        case '3':
            this.setState({ permissao: '/supervisor' });
            break;
        case '2':
            this.setState({ permissao: '/coordenador' });
            break;
        default:
            this.setState({ permissao: '/vendedor' });
            break;
        }

        this.setState({ loading: 'nada',
            submit: true });
        this.setState({ cod: decriptoLocalStorage('codigo_vendedor')?.decriptoValue });

        this.setState({ loading: 'nada',
            submit: true });
        this.busca(this.codigo);
    }

    buscaTabela = async codigo => {
        await buscaHieraquia(this.state.permissao, { Codigo: codigo })
            .then(result => {
                this.setState({ hierarquia: result });
            })
            .catch(error => {
                console.error(error);
                alert('Error ao carregar os dados!');
            });
    };

    onClick(name, position) {
        let state = {
            [`${name}`]: true
        };

        if (position) {
            state = {
                ...state,
                position
            };
        }

        this.setState(state);
    }

    onHide(name) {
        this.setState({
            [`${name}`]: false
        });
    }

    atualizarGraficos = () => {
        window.location.reload();
    };

    somaComicao = async () => {
        const dados = {
            Codigo: this.codigo,
            data_inicio: moment().format('YYYY-MM-01'),
            data_fim: moment().format('YYYY-MM-DD'),
            area: areaColaborador
        };

        await CalculoComissao('coordenador', dados)
            .then(resp=>{
                this.setState({ comissao: resp });
            }).catch (error => {
                console.err(error);
            });
    };

    busca = async codigo => {
        await Buscar(codigo, this.permissao)
            .then(response => {
                this.entregues();
                this.buscaTabela(codigo);
                //this.setState({ totalRecebidos: response })
                this.somaComicao();
            })
            .catch(function (erro) {
                this.entregues();
                this.setState({ loading: 'loading',
                    submit: true });
            });
    };

    entregues = async () => {
        // await BuscarEntregues(codigo)
        //     .then(result => {
        //this.setState({ totalEntregues: result })
        this.buscaVend(this.codigo);

        // }).catch(function (erro) {
        //     this.buscaVend(codigo);
        //     this.setState({ loading: 'loading', submit: true });
        // });
    };

    buscaVend = async codigo => {
        await coordenadorVendas(codigo)
            .then(resp => {
                this.setState({ dados: resp });
                setTimeout(() => {
                    this.setState({ loading: 'loading',
                        submit: false });
                }, 1000);
            })
            .catch(err => {
                console.log(err);
                this.busca(this.state.cod);
            });

        await coordenadorVendasOnly(codigo)
            .then(resp => {
                this.setState({ date: resp });
                this.setState({ dato: resp });
                setTimeout(() => {
                    this.setState({ loading: 'loading',
                        submit: false });
                }, 1000);
            })
            .catch(err => {
                console.log(err);
                this.busca(this.state.cod);
            });

        await coordenadorVendasOnlySupervisores(codigo)
            .then(resp => {
                this.setState({ dato: resp });
                setTimeout(() => {
                    this.setState({ loading: 'loading',
                        submit: false });
                }, 1000);
            })
            .catch(err => {
                console.log(err);
                this.busca(this.state.cod);
            });
    };

    updatedField(event) {
        const vendedorVendas = event.target.value;

        this.setState({ bodyVend: vendedorVendas });
    }

    updatedField2(event) {
        const bodySup = event.target.value;

        this.setState({ bodySupp: bodySup });
    }

    updatedField3(event) {
        const body = {
            vendedor: event.target.value
        };

        api.post(`/coordenador/graficoCoordenadorNome/${this.codigo}`, body)
            .then(resp => {
                this.setState({ date: resp.data });
            })
            .catch(err => {
                this.busca(this.state.cod);
                console.log(err);
            });
    }

    updatedField4(event) {
        const body = {
            supervisor: event.target.value
        };

        api.post(`/coordenador/graficoCoordenadorNomeTotal/${this.codigo}`, body)
            .then(resp => {
                this.setState({ dato: resp.data });
            })
            .catch(err => {
                this.busca(this.state.cod);
                console.log(err);
            });
    }

    updatedField5(event) {
        const enviarBody = event.target.value;
        const mes = enviarBody.substring(0, enviarBody.search('/'));
        const ano = enviarBody.substring(enviarBody.search('/') + 1);

        this.setState({ dataMes: parseInt(mes) });
        this.setState({ dataAno: parseInt(ano) });
    }

    save() {
        const body = {
            dataMes: this.state.dataMes,
            dataAno: this.state.dataAno,
            vendedor: this.state.bodyVend,
            supervisor: this.state.bodySupp
        };

        api.post(`/coordenador/graficoCoordenador/${this.codigo}`, body)
            .then(resp => {
                this.setState({ dados: resp.data });
            })
            .catch(err => {
                this.busca(this.state.cod);
                console.log(err);
            });
    }

    render() {
        // var totalRecebidos = this.state.totalRecebidos.length
        // var totalEntregues = this.state.totalEntregues.length
        const regra = this.state.dados;
        let dados;
        const nomes = [];
        let metas = [];
        let total = areaColaborador == 'PRIME' ? 1440 : 3120;
        const num = areaColaborador == 'PRIME' ? 480 : 1040;

        regra.forEach((value, i) => {
            dados = value.Mes;
            value.Nome = meses[dados];
            nomes[i] = value.Nome;
        });

        const mes = this.state.dados.map(values => values.Total);

        if (nomes.length === 4) {
            metas = [1040, 1040, 1040, 1040];
        }

        if (nomes.length === 3) {
            metas = [1040, 1040, 1040];
        }

        if (nomes[2]) {
            total = total - mes[2];

            if (total < mes[2]) {
                total = 0;
            }
        }

        const data = {
            labels: nomes,
            datasets: [
                {
                    label: 'Vendas Aprovadas',
                    backgroundColor: '#F4C27A',
                    data: mes
                },
                {
                    label: 'Metas de Venda',
                    backgroundColor: '#27348B',
                    data: [num, num, num, num]
                }
            ]
        };

        const options = {
            title: {
                display: true,
                text: 'Venda nos ultimos meses',
                fontSize: 15
            },
            legend: {
                position: 'bottom',
                width: 1
            },
            barPercentage: 0.5,
            barThickness: 6,
            maxBarThickness: 8,
            minBarLength: 2,
            scales: {
                xAxes: [
                    {
                        stacked: false
                    }
                ],
                yAxes: [
                    {
                        stacked: false
                    }
                ]
            }
        };

        const mesTotal = this.state.dados.map(values => values.Total);

        const mes2 = mesTotal.reduce((a, b) => a + b, 0);

        const a = this.state.dados.map(values => values.Total);

        let vendasTotal;

        if (vendasTotal === undefined) {
            vendasTotal = 0;
        }

        if (a[2]) {
            vendasTotal = a[2];
        }

        if (a[2] === null || a[2] === undefined) {
            vendasTotal = a[0];
        }

        if (a.length === 0) {
            vendasTotal = 0;
        }

        const options2 = {
            title: {
                display: true,
                text: `Total de Vendas : ${vendasTotal}`,
                fontSize: 15
            },
            legend: {
                position: 'bottom',
                width: 1
            },
            cutoutPercentage: 50,
            circumference: Math.PI,
            rotation: Math.PI
        };

        if (mes2 > total) {
            total = 0;
        }

        const data2 = {
            labels: ['Total de vendas', 'Metas Restantes'],
            datasets: [
                {
                    data: [vendasTotal, 1040],
                    backgroundColor: ['#96C929']
                }
            ]
        };

        const dat = [];

        const vendedoresNome = this.state.date.map(value => {
            dat.push(78);

            return value['Vendedore.Nome'];
        });

        const data3 = {
            labels: vendedoresNome,
            datasets: [
                {
                    label: 'Vendas Aprovadas',
                    backgroundColor: '#F4C27A',
                    data: this.state.date.map(value => value.Total)
                },
                {
                    label: 'Metas de Venda',
                    backgroundColor: '#27348B',
                    data: dat
                }
            ]
        };

        const options3 = {
            title: {
                display: true,
                text: 'Vendas total por Vendedores',
                fontSize: 15
            },
            legend: {
                position: 'bottom',
                width: 1
            },
            barPercentage: 0.5,
            barThickness: 6,
            maxBarThickness: 8,
            minBarLength: 2,
            scales: {
                xAxes: [
                    {
                        stacked: false
                    }
                ],
                yAxes: [
                    {
                        stacked: false
                    }
                ]
            }
        };

        const tad = [];
        const supervisoresNome = this.state.dato.map(value => {
            tad.push(312);

            return value['Supervisore.Nome'];
        });

        const data4 = {
            labels: supervisoresNome,
            datasets: [
                {
                    label: 'Vendas Aprovadas',
                    backgroundColor: '#F4C27A',
                    data: this.state.dato.map(value => value.Total)
                },
                {
                    label: 'Metas de Venda',
                    backgroundColor: '#27348B',
                    data: tad
                }
            ]
        };

        const options4 = {
            title: {
                display: true,
                text: 'Vendas total por Supervisores',
                fontSize: 15
            },
            legend: {
                position: 'bottom',
                width: 1
            },
            barPercentage: 0.5,
            barThickness: 6,
            maxBarThickness: 8,
            minBarLength: 2,
            scales: {
                xAxes: [
                    {
                        stacked: false
                    }
                ],
                yAxes: [
                    {
                        stacked: false
                    }
                ]
            }
        };

        const header = <img alt="Card" src={fundo_amarelo} />;

        return (
            <>
                <div className={this.state.loading}>
                    <ProgressSpinner
                        style={{
                            width: '300px',
                            height: '150px',
                            display: 'flex',
                            margin: '0 auto',
                            marginTop: '8%'
                        }}
                        strokeWidth="1"
                        fill="#EEEEEE"
                        animationDuration=".5s"
                    />
                </div>
                {this.state.submit !== true ? (
                    <Card className='tratar-scroll-card' header={header} title="Home">
                        <div className="group">
                            <Button
                                label="Abrir Hierarquia"
                                onClick={() => this.onClick('displayBasic')}
                            />

                            <Dialog
                                header="Hierarquia"
                                visible={this.state.displayBasic}
                                style={{ width: '75vw' }}
                                maximizable
                                onHide={() => this.onHide('displayBasic')}
                            >
                                <Organograma
                                    dadosHierarquia={this.state.hierarquia}
                                />
                            </Dialog>
                            <br />
                            <Card>
                                <div className="p-grid">
                                    <h2 style={{ marginLeft: '30%' }}>
                                        <b>Vendas Gerais</b>
                                    </h2>
                                    <div className="p-col-12 p-md-12 p-lg-12">
                                        <label>
                                            <h3
                                                style={{
                                                    color: 'black',
                                                    marginBottom: '1%'
                                                }}
                                            >
                                                Filtrar Gráfico Geral
                                            </h3>
                                            <InputMask
                                                mask="99/9999"
                                                placeholder="Data ex:10/2020"
                                                maskChar={null}
                                                style={{ height: '33px' }}
                                                type="text"
                                                onChange={e =>
                                                    this.updatedField5(e)
                                                }
                                            />{' '}
                                            <a />
                                            <InputText
                                                type="text"
                                                placeholder="Nome do Vendedor"
                                                onChange={e =>
                                                    this.updatedField(e)
                                                }
                                            />{' '}
                                            <a /> <a />
                                            <InputText
                                                type="text"
                                                placeholder="Nome do Supervisor"
                                                onChange={e =>
                                                    this.updatedField2(e)
                                                }
                                            />{' '}
                                            <a /> <a />
                                            <Button
                                                label="Filtrar"
                                                onClick={() => this.save()}
                                            />
                                            <br />
                                            <br />
                                            <Button
                                                label="Atualizar gráficos"
                                                style={{
                                                    backgroundColor: '#E1E1E1',
                                                    borderColor: 'gray',
                                                    color: 'gray'
                                                }}
                                                onClick={() =>
                                                    this.atualizarGraficos()
                                                }
                                            />
                                        </label>
                                        {/**descomentar link quando homologado relatórios */}
                                        {/*<Link to="/relatorio">*/}
                                        <a
                                            style={{
                                                color: 'gray',
                                                border: '1px solid gray',
                                                borderRadius: '3px',
                                                marginLeft: '4px'
                                            }}
                                            className="p-col-12 p-md-12 p-lg-12"
                                        >
                                            <i
                                                className="pi pi-money-bill"
                                                style={{ color: '#27348B' }}
                                            ></i>
                                            Comissão:{' '}
                                            {this.state.comissao.totalAdesao}
                                        </a>
                                        {/*</Link>*/}
                                    </div>
                                </div>
                                <br />
                                <div className="p-grid p-fluid">
                                    <div className="p-col-12 p-md-6 p-lg-6 p-sm-6">
                                        <Chart
                                            type="bar"
                                            data={data}
                                            options={options}
                                        />
                                    </div>
                                    <div className="p-col-12 p-md-6 p-lg-6 p-sm-6">
                                        <Chart
                                            type="doughnut"
                                            options={options2}
                                            data={data2}
                                        />
                                    </div>
                                </div>
                            </Card>
                            <br />
                            <br />
                            <Card>
                                <h2 style={{ marginLeft: '30%' }}>
                                    <b>Vendas Supervisor</b>
                                </h2>
                                <div className="p-col-12 p-md-6 p-lg-6">
                                    <label style={{ width: '100' }}>
                                        <h3
                                            style={{
                                                color: 'black',
                                                marginBottom: '1%'
                                            }}
                                        >
                                            Filtrar Gráfico Supervisor
                                        </h3>
                                        <InputText
                                            type="text"
                                            placeholder="Nome do supervisor"
                                            onChange={e =>
                                                this.updatedField4(e)
                                            }
                                        />
                                        {/* <Button type="submit" label="Filtrar" onClick={() => this.save()} /> */}
                                    </label>
                                </div>
                                <div className="p-grid p-fluid">
                                    <div className="p-col-11 p-md-11 p-lg-11 p-sm-11">
                                        <Chart
                                            type="bar"
                                            data={data4}
                                            options={options4}
                                        />
                                    </div>
                                </div>
                            </Card>
                            <Card>
                                <h2 style={{ marginLeft: '30%' }}>
                                    <b>Vendas Vendedor</b>
                                </h2>
                                <div className="p-col-12 p-md-6 p-lg-6">
                                    <label style={{ width: '100' }}>
                                        <h3
                                            style={{
                                                color: 'black',
                                                marginBottom: '1%'
                                            }}
                                        >
                                            Filtrar Gráfico Vendedor
                                        </h3>
                                        <InputText
                                            type="text"
                                            placeholder="Nome do vendedor"
                                            onChange={e =>
                                                this.updatedField3(e)
                                            }
                                        />
                                        {/* <Button type="submit" label="Filtrar" onClick={() => this.save()} /> */}
                                    </label>
                                </div>
                                <div className="p-grid p-fluid">
                                    <div className="p-col-11 p-md-11 p-lg-11 p-sm-11">
                                        <Chart
                                            type="bar"
                                            data={data3}
                                            options={options3}
                                        />
                                    </div>
                                </div>
                            </Card>
                        </div>
                    </Card>
                ) : null}
            </>
        );
    }
}
